import { render, staticRenderFns } from "./CompaniesRegistered.html?vue&type=template&id=e133e0f2&lang=html&external"
import script from "./CompaniesRegistered.vue?vue&type=script&lang=js"
export * from "./CompaniesRegistered.vue?vue&type=script&lang=js"
import style0 from "./CompaniesRegistered.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports